import React from 'react';
import { useLocation } from 'react-router-dom';

import Header from '../../Components/layout/Header';

const DefaultLayout = props => {
  const location = useLocation();

  return (
    <>
      {location.pathname === '/termsandconditions' ? (
        <div className="defaultLayout1">{props.children}</div>
      ) : (
        <div className="defaultLayout">
          <Header {...props} />
          {props.children}
        </div>
      )}
    </>
  );
};

export default DefaultLayout;
